module.exports = __webpack_public_path__ + "img/calidad.f21405a4.jpeg";